import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
import { ApiContext } from "../../../App";
import { toast } from 'react-toastify';


// 5. Hook personnalisé pour la logique métier
export const useIndividualsData = () => {
  const API = useContext(ApiContext);
  const [individuals, setIndividuals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [positions, setPositions] = useState([]);
  const [candidateMap, setCandidateMap] = useState({});
  const [bizdevProcesses, setBizdevProcesses] = useState([]);
  const [bizdevProcessMap, setBizdevProcessMap] = useState({});

  const fetchIndividuals = useCallback(async () => {
    setLoading(true);
    try {
      const response = await API.get("/api/individuals/company");
      // S'assurer que response.data est un tableau, sinon utiliser un tableau vide
      setIndividuals(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error("Error fetching individuals:", error);
      // En cas d'erreur, s'assurer que individuals est un tableau vide
      setIndividuals([]);
    } finally {
      setLoading(false);
    }
  }, [API]);

  const fetchPositions = useCallback(async () => {
    try {
      const response = await API.get("/api/positions");
      setPositions(response.data);

      // Create candidate mapping
      const mapping = {};
      response.data.forEach(position => {
        if (position.candidates && position.candidates.length > 0) {
          position.candidates.forEach(candidate => {
            if (candidate.individual) {
              const individualId = typeof candidate.individual === 'object'
                ? candidate.individual._id
                : candidate.individual;

              if (!mapping[individualId]) {
                mapping[individualId] = [];
              }

              mapping[individualId].push({
                positionId: position._id,
                positionTitle: position.title,
                stage: candidate.stage
              });
            }
          });
        }
      });

      setCandidateMap(mapping);
    } catch (error) {
      console.error("Error fetching positions:", error);
    }
  }, [API]);

  const fetchBizdevProcesses = useCallback(async () => {
    try {
      const response = await API.get("/api/process-bizdev");
      setBizdevProcesses(response.data);

      // Create bizdev process mapping
      const mapping = {};
      response.data.forEach(process => {
        if (process.prospects && process.prospects.length > 0) {
          process.prospects.forEach(prospect => {
            if (prospect.individual) {
              const individualId = typeof prospect.individual === 'object'
                ? prospect.individual._id
                : prospect.individual;

              if (!mapping[individualId]) {
                mapping[individualId] = [];
              }

              mapping[individualId].push({
                processId: process._id,
                processName: process.name,
                currentStep: prospect.currentStep
              });
            }
          });
        }
      });

      setBizdevProcessMap(mapping);
    } catch (error) {
      console.error("Error fetching bizdev processes:", error);
    }
  }, [API]);

  const deleteIndividual = useCallback(async (id) => {
    setLoading(true);
    try {
      await API.delete(`/api/individuals/${id}`);
      setIndividuals(prev => prev.filter(ind => ind._id !== id));
      toast.success("Contact supprimé avec succès");
    } catch (error) {
      console.error("Error deleting individual:", error);
      toast.error("Erreur lors de la suppression du contact");
    } finally {
      setLoading(false);
    }
  }, [API]);

  return {
    individuals,
    setIndividuals,
    loading,
    positions,
    candidateMap,
    bizdevProcesses,
    bizdevProcessMap,
    fetchIndividuals,
    fetchPositions,
    fetchBizdevProcesses,
    deleteIndividual
  };
};